var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoundary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01578 0.964459L13.6507 3.61297C14.2887 3.94178 14.6673 4.6478 14.6673 5.33317V10.6665C14.6673 11.3519 14.2887 12.0579 13.6507 12.3867L9.01579 15.0352C8.40161 15.4325 7.59969 15.4325 6.98551 15.0352L2.35063 12.3867C1.71264 12.0579 1.33398 11.3519 1.33398 10.6665V5.33317C1.33398 4.6478 1.71264 3.94178 2.35063 3.61297L6.98552 0.964459C7.59969 0.567185 8.40161 0.567185 9.01578 0.964459ZM8.29752 2.08787C8.12145 1.97049 7.87985 1.97049 7.70378 2.08787C7.69105 2.09636 7.67803 2.10441 7.66474 2.112L3.36693 4.5679L8.00063 7.23095L12.6344 4.56789L8.33656 2.112C8.32327 2.10441 8.31025 2.09636 8.29752 2.08787ZM2.66732 10.6665V5.70367L7.33398 8.38566V13.6987L2.99808 11.221C2.98737 11.2149 2.97649 11.2091 2.96546 11.2036C2.81466 11.1282 2.66732 10.9078 2.66732 10.6665ZM8.66732 13.6987L13.0032 11.221C13.0139 11.2149 13.0248 11.2091 13.0358 11.2036C13.1866 11.1282 13.334 10.9078 13.334 10.6665V5.70365L8.66732 8.38564V13.6987Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.10647,
    y1: -4.68799,
    x2: 7.97843,
    y2: 15.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoundary);
export default __webpack_public_path__ + "static/media/boundary.6064ae6b.svg";
export { ForwardRef as ReactComponent };